
import { GroupCardScreenNavigationProps } from "./types"
import React from "react"
import GroupCard from "./group-card-screen"
import { PageRoot } from "~screens/page-root"


const GroupCardScreen: React.FC<GroupCardScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <GroupCard chat={route.params?.chat} />
    </PageRoot>
  )
}

export default GroupCardScreen
